import { useState, useEffect } from 'react';

import Modal from '../../../common/modal/Modal';
import TextInput from '../../../common/inputs/text-input/TextInput';
import Button from '../../../common/button/Button';

import './add-representative-modal.scss';

const AddRepresentativeModal = ({ show, setShow, addRepresentative }) => {
  const [email, setEmail] = useState('');
  const [showSuccessMessage, setShowSuccessMessage] = useState(false);

  useEffect(() => {
    if (show) {
      setEmail('');
      setShowSuccessMessage(false);
    }
  }, [show]);

  const handleAddClick = () => {
    addRepresentative(email, () => setShowSuccessMessage(true));
  };

  const renderContent = () => {
    if (showSuccessMessage) {
      return (
        <div className="add-representative-modal__success-message-container">
          <p className="add-representative-modal__success-title">Thank you.</p>
          <p className="add-representative-modal__success-message">An email has been sent to the address.</p>
          <Button className="add-representative-modal__success-button" onClick={() => setShow(false)}>
            OKAY
          </Button>
        </div>
      );
    }

    return (
      <>
        <p className="add-representative-modal__title">Please add the new representative's email address</p>
        <label className="add-representative-modal__label" htmlFor="email">
          Email
        </label>
        <TextInput name="email" value={email} onChange={({ target }) => setEmail(target.value)} />

        <section className="add-representative-modal__buttons">
          <Button className="add-representative-modal__button" onClick={() => setShow(false)} secondary>
            CANCEL
          </Button>
          <Button className="add-representative-modal__button" onClick={handleAddClick}>
            ADD
          </Button>
        </section>
      </>
    );
  };

  return (
    <Modal show={show} setShow={setShow}>
      <section className="add-representative-modal">{renderContent()}</section>
    </Modal>
  );
};

export default AddRepresentativeModal;
